import axios from 'axios'

const apiURL = process.env.REACT_APP_API_URL


export interface TimesheetEntry {
    jobReference: string
    clientName: string
    description: string
    jobId: number
    notes: string
    siteAddress: string
    timeSheetDate: string
    timeSheetEntryId: number
    timeSheetId: number
    timeSpent: number
}



export const getTimesheetByEmployeeIdYearWeek = async (employeeId: number, year: number, week: number): Promise<TimesheetEntry[]> => {
    const token = localStorage.getItem('authToken')

    if (!token) {
        throw new Error('Authorization token not found')
    }

    const response: any = await axios.get(
        `https://${apiURL}/timesheetentry/${employeeId}/${year}/${week}`,
        {
            headers: {
                'Content-Type': 'application/json',
                Authorization: 'Bearer ' + token,
            },
        }
    )
    return response.data
}

export const getTimesheetEntryById = async (timeSheetEntryId: number): Promise<TimesheetEntry> => {
    const token = localStorage.getItem('authToken')

    if (!token) {
        throw new Error('Authorization token not found')
    }

    const response: any = await axios.get(
        `https://${apiURL}/timesheetentry/${timeSheetEntryId}`,
        {
            headers: {
                'Content-Type': 'application/json',
                Authorization: 'Bearer ' + token,
            },
        }
    )
    return response.data
}

interface UpdateTimesheetEntry { 
    timeSheetId: number
    jobId: number
    timeSpent: number
    notes: string
    timeSheetEntryId: number
}

export const updateTimesheetEntryById = async (props: UpdateTimesheetEntry): Promise<TimesheetEntry> => {
    const token = localStorage.getItem('authToken')

    if (!token) {
        throw new Error('Authorization token not found')
    }

    const response: any = await axios.put(
        `https://${apiURL}/timesheetentry/${props.timeSheetEntryId}`,
        props,
        {
            headers: {
                'Content-Type': 'application/json',
                Authorization: 'Bearer ' + token,
            },
        }
    )
    return response.data
}

export const deleteTimesheetEntryById = async (timeSheetEntryId: number ): Promise<any> => {
    const token = localStorage.getItem('authToken')

    if (!token) {
        throw new Error('Authorization token not found')
    }

    const response: any = await axios.delete(
        `https://${apiURL}/timesheetentry/${timeSheetEntryId}`,
        {
            headers: {
                'Content-Type': 'application/json',
                Authorization: 'Bearer ' + token,
            },
        }
    )
    return response.data
}

export const checkTimesheetExists = async (employeeId: number, day: string): Promise<any> => {
    const token = localStorage.getItem('authToken')

    if (!token) {
        throw new Error('Authorization token not found')
    }

    const response: any = await axios.get(
        `https://${apiURL}/timesheet/date/${day}/${employeeId}`,
        {
            headers: {
                'Content-Type': 'application/json',
                Authorization: 'Bearer ' + token,
            },
        }
    )
    return response.data
}

interface CreateTimesheet { 
    date: string
    startTime: string
    employeeId: number
}

export const createTimesheet = async (props: CreateTimesheet): Promise<any> => {
    const token = localStorage.getItem('authToken')

    if (!token) {
        throw new Error('Authorization token not found')
    }

    const response: any = await axios.post(
        `https://${apiURL}/timesheet/`,
        {
            ...props,
            status: 0
        },
        {
            headers: {
                'Content-Type': 'application/json',
                Authorization: 'Bearer ' + token,
            },
        }
    )
    return response.data
}

interface CreateTimesheetEntry  { 
    timeSheetId: number
    timeSpent: number
    jobId: number
    notes: string
}

export const createTimesheetEntry = async (props: CreateTimesheetEntry): Promise<any> => {
    const token = localStorage.getItem('authToken')

    if (!token) {
        throw new Error('Authorization token not found')
    }

    const response: any = await axios.post(
        `https://${apiURL}/timesheetentry/`,
        props,
        {
            headers: {
                'Content-Type': 'application/json',
                Authorization: 'Bearer ' + token,
            },
        }
    )
    return response.data
}
